import { env } from "@/web/lib/env";

/**
 * Absolute origins for links that must name a host (og:url, links out to the
 * marketing site), set per GitHub Environment. Both default to production:
 *
 *   VITE_APP_ORIGIN          https://with.co   (this app)
 *   VITE_MARKETING_SITE_URL  https://with.us   (the static manifesto site)
 */
export const APP_ORIGIN = (env.VITE_APP_ORIGIN ?? "https://with.co").replace(/\/+$/, "");

export const MARKETING_SITE_URL = env.VITE_MARKETING_SITE_URL ?? "https://with.us";

/** Absolute URL for an app path, e.g. `appUrl("/faq")`. */
export function appUrl(path: string): string {
  return `${APP_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
